import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {Fill, RegularShape, Stroke, Style} from "ol/style";
import {COLOURS} from "./Colours";

export class RemainingLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = new Style({
        image: new RegularShape({
            fill: new Fill({color: COLOURS.HUMP.VISITED}),
            stroke: new Stroke({color: "white", width: 2}),
            points: 4,
            radius: 6,
        }),
    });

    private unvisitedStyle = new Style({
        image: new RegularShape({
            fill: new Fill({color: COLOURS.HUMP.UNVISITED}),
            stroke: new Stroke({color: "white", width: 2}),
            points: 4,
            radius: 6,
        }),
    });

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hillLists: HillLists): Hill[] {
        const combined = [...hillLists.others, ...hillLists.lakes];
        return combined.filter((h) => !h.categories.length);
    }

    setupGPX() {
        const elem = document.getElementById("gpx_other");
        if (elem) {
            this.setGPXClickListener(elem, "others.gpx");
        }
    }

    getName(): string {
        return "Others";
    }
}
